// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5380b0fb","498":"5bddb83a","513":"09274eef","787":"0979e147"}[chunkId] + ".chunk.js";
};